import {BigDecimal, Money} from '@dms/api/shared';

export type PriceValueType = {
  readonly vatDeductible?: boolean;
  readonly vatRate?: BigDecimal | null;
  value: Money;
  withVat: boolean;
  vatCode?: string | null;
  countryCode?: string;
};
